<template>
  <noscript>
    <iframe
      :src="_gtmNoscriptSrc"
      height="0"
      width="0"
      style="display: none; visibility: hidden"
      title="Google Tag Manager" />
  </noscript>
</template>

<script setup lang="ts">
import { GTM_CONTAINER_ID } from '~/constants/analytics'

const _gtmNoscriptSrc: string = `https://www.googletagmanager.com/ns.html?id=${GTM_CONTAINER_ID}`
</script>
